export const pageFooter = {
	address: {
		heading: {
			sv: "Besöksadress",
		},
		address: {
			sv: "Evenemangsgatan 31 169 81 Solna",
		},
	},
	customerService: {
		heading: {
			sv: "Kundtjänst",
		},
		phone: {
			sv: "08-616 99 00",
		},
		open: {
			sv: "Måndag-fredag 08:00-17:00",
		},
	},
	copyright: {
		sv: "© {0} Svea Bank — org.nr 556158-7634",
	},
};
